<template>
  <div>
    <!-- UI to display first and last name and a button to trigger editing. -->
    <v-layout align-center>
      <div>
        {{ user.first_name }} {{ user.last_name }}
        <div
          v-if="isEmpty && showWarningWhenEmpty"
          align-center
          class="subheading warning--text font-weight-bold"
        >
          {{ $t('userManagementEditUserNamesEmptyWarning') }}
        </div>
      </div>
      <!-- Edit first_name and last_name button -->
      <v-btn
        v-if="showEditButton"
        icon
        :small="small"
        class="edit-names-btn ml-1"
        :class="{small: small}"
        :title="$t('userManagementEditUserNames')"
        @click.stop="showEditUserNamesDialog = true"
      >
        <v-icon
          color="msr"
          :small="small"
        >
          edit
        </v-icon>
      </v-btn>
    </v-layout>
    <!-- Dialog to set a new first and lastname -->
    <edit-user-names-dialog
      :show.sync="showEditUserNamesDialog"
      :busy="renaming"
      :user="user"
      @confirm="
        (newFirstName, newLastName) =>
          editManagedUserNames(user, newFirstName, newLastName)
      "
    />
  </div>
</template>

<script>
import EditUserNamesDialog from '@/components/EditUserNamesDialog';

export default {
  name: 'EditUserNames',
  components: {
    EditUserNamesDialog,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    showEditButton: {
      type: Boolean,
      required: true,
    },
    showWarningWhenEmpty: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showEditUserNamesDialog: false,
      renaming: false,
    };
  },
  computed: {
    isEmpty() {
      return (
        !(this.user.first_name || '').trim() &&
        !(this.user.last_name || '').trim()
      );
    },
  },
  methods: {
    editManagedUserNames(user, firstName, lastName) {
      this.renaming = true;
      this.$api
        .editUserNames(user.id, firstName, lastName)
        .then(() => {
          this.$bus.$emit('alert-success', {
            message: 'genericEntryUpdateSuccess',
            translate: true,
          });

          const renamedHimself = this.$user.id === user.id;
          if (renamedHimself) {
            this.$store.dispatch('RETRIEVE_CURRENT_USER');
          } else {
            this.$store.commit('EDIT_MANAGED_USER_NAME', {
              id: user.id,
              firstName: firstName,
              lastName: lastName,
            });
          }

          this.showEditUserNamesDialog = false;
        })
        .catch((error) => {
          console.error(error);

          this.$bus.$emit('alert-error', {
            message: 'genericFailFeedback',
            translate: true,
          });
        })
        .finally(() => {
          this.renaming = false;
        });
    },
  },
};
</script>

<style scoped>
.edit-names-btn {
  margin: 0;
}
.edit-names-btn.small {
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserManagement/EditManagedUserNames.vue